import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTER_PATH } from 'router/const/routerPath.const';
import { getExtraCashConversionValue, thousandFormatterOrHyphen } from 'modules/core/utils';

interface IExtraCashCell {
  extraCashValue: number | null;
}
export const ExtraCashCell: FC<IExtraCashCell> = ({ extraCashValue }) => {
  const { pathname } = useLocation();

  const isExtraCashFormatted = pathname === ROUTER_PATH.PROBABILITY_ESTIMATOR && typeof extraCashValue === 'number';

  return (
    <>
      {isExtraCashFormatted ? getExtraCashConversionValue(extraCashValue) : thousandFormatterOrHyphen(extraCashValue)}
    </>
  );
};
